import React, { useEffect, useState } from "react"
import useT from "../hooks/useT"
import useAsync from "../hooks/useAsync"
import { UserPreferences } from "../storeApi"
import { Section, Card, Loading, ErrorText } from "./ui"

// one switch for every letter of ours beyond the orders' own: offers, news, personal suggestions and the reminders
// of a cart left (api: commerce/lib/winback reads it); the old second switch (personalized_marketing) said the same
const KEYS = ["direct_marketing"]

function Toggle({ checked, onChange, label, name }) {
  return (
    <label className="flex items-center justify-between gap-4 py-3 cursor-pointer">
      <span className="text-[15px]">{label}</span>
      <input type="checkbox" name={name} checked={checked} onChange={(e) => onChange(e.target.checked)} className="sr-only peer" />
      <span className="relative h-7 w-12 shrink-0 rounded-full bg-neutral_2 transition-colors peer-checked:bg-primary after:absolute after:top-1 after:left-1 after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-transform peer-checked:after:translate-x-5" />
    </label>
  )
}

/** Marketing preferences (user {preferences}). */
export default function Privacy() {
  const t = useT()
  const { result, pending } = useAsync(() => UserPreferences(KEYS.join(" ")), [])
  const [prefs, setPrefs] = useState({})
  const [error, setError] = useState(null)

  useEffect(() => {
    if (result && !result.error) setPrefs(result)
  }, [result])

  const update = async (key, value) => {
    setPrefs((p) => ({ ...p, [key]: value }))
    const response = await UserPreferences({ [key]: value }).catch((e) => ({ error: e.message }))
    if (response?.error) setError(t(response.error))
  }

  if (pending && !result) return <Loading />

  return (
    <Section title={t`Privacy`}>
      <ErrorText>{error || result?.error}</ErrorText>
      <Card>
        <Toggle name="direct_marketing" label={t`direct_marketing_message`} checked={prefs.direct_marketing !== false} onChange={(v) => update("direct_marketing", v)} />
      </Card>
      <p className="m-0 text-[14px] text-text_secondary">
        {t`Read our`}{" "}
        <a href="/privacy-policy" className="font-bold text-primary hover:underline">
          {t`Privacy Policy`}
        </a>
      </p>
    </Section>
  )
}
